// Home card: next events from the shared hub calendar, fetched live with the
// viewer's token (Phase 5). Self-contained (own settings watch + fetch state)
// so HomeView stays presentational. SSR renders the disconnected hint; the
// fetch runs only in an effect.
import { useEffect, useState } from 'react'
import { useGoogle } from '../lib/useGoogle.js'
import { calendarListUpcoming, hasConnectedBefore } from '../lib/google.js'
import { watchGoogleSettings } from '../lib/data.js'

export default function UpcomingCalendarCard() {
  const g = useGoogle()
  const [calendarId, setCalendarId] = useState(null)
  const [events, setEvents] = useState(null) // null = loading/not-fetched
  const [error, setError] = useState(null)

  useEffect(() => watchGoogleSettings((s) => setCalendarId(s?.calendarId || null)), [])

  useEffect(() => {
    if (typeof window === 'undefined' || !calendarId || !hasConnectedBefore()) return
    let alive = true
    calendarListUpcoming(calendarId, { maxResults: 10 })
      .then((evts) => { if (alive) { setEvents(evts); setError(null) } })
      .catch((e) => { if (alive) setError(e.message) })
    return () => { alive = false }
  }, [calendarId, g.status])

  const fmtStart = (s) => {
    const d = new Date(s)
    return isNaN(d) ? s : d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
  }

  const connected = g.status === 'connected' || (typeof window !== 'undefined' && hasConnectedBefore())

  return (
    <div>
      <div className="tag-label" style={{ color: 'var(--color-muted)', marginBottom: 12 }}>Upcoming from Calendar</div>
      {!connected && (
        <div style={{ fontSize: 12, color: 'var(--color-muted)' }}>Connect Google in Settings to see the shared calendar here.</div>
      )}
      {connected && !calendarId && (
        <div style={{ fontSize: 12, color: 'var(--color-muted)' }}>Set the shared calendar ID in Settings.</div>
      )}
      {connected && calendarId && error && <div style={{ fontSize: 12, color: 'var(--color-danger)' }}>{error}</div>}
      {connected && calendarId && !error && events === null && (
        <div style={{ fontSize: 12, color: 'var(--color-muted)' }}>Loading…</div>
      )}
      {connected && calendarId && !error && events && events.length === 0 && (
        <div style={{ fontSize: 12, color: 'var(--color-muted)' }}>No upcoming events.</div>
      )}
      {connected && calendarId && !error && (events || []).map((e) => (
        <div key={e.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 0', borderBottom: '1px solid var(--surface-row)' }}>
          <span className="font-mono" style={{ fontSize: 11, color: 'var(--color-gold)', minWidth: 48 }}>{fmtStart(e.start)}</span>
          {e.htmlLink ? (
            <a href={e.htmlLink} target="_blank" rel="noreferrer" style={{ fontSize: 13, color: 'var(--color-white)', textDecoration: 'none', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{e.summary}</a>
          ) : (
            <span style={{ fontSize: 13, color: 'var(--color-white)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{e.summary}</span>
          )}
        </div>
      ))}
    </div>
  )
}
